import { Link } from "react-router-dom";
import { Monitor, ChevronLeft } from "lucide-react";
import { FeedbackButton } from "@/components/studio/FeedbackButton";
import { useIsMobile } from "@/lib/useIsMobile";

export const DesktopNotice = ({ title = "This part is made for desktop.", text = "Open LoreRight on a computer to use it. Everything you do there syncs back here.", backTo, backLabel = "Back" }) => (
  <div className="flex h-full min-h-[60vh] flex-col items-center justify-center p-8 text-center" data-testid="studio-desktop-only">
    <div className="flex h-14 w-14 items-center justify-center rounded-full border border-[#2D3442] bg-[#13171F]"><Monitor className="h-6 w-6 text-[#F59E0B]" /></div>
    <p className="mt-5 font-display text-3xl text-[#F3EBDD]">{title}</p>
    <p className="mt-2 max-w-xs text-sm text-[#A8A090]">{text}</p>
    {backTo && <Link to={backTo} className="mt-6 inline-flex items-center gap-1 text-sm text-[#F59E0B] hover:underline" data-testid="desktop-notice-back"><ChevronLeft className="h-4 w-4" />{backLabel}</Link>}
  </div>
);

export const DesktopHint = ({ children, testid = "mobile-desktop-hint" }) => (
  <p className="flex items-start gap-2 rounded-md border border-dashed border-[#2D3442] px-3 py-2 text-xs text-[#A8A090]" data-testid={testid}><Monitor className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#F59E0B]" /><span>{children}</span></p>
);

export const DesktopOnly = ({ children, backTo, backLabel }) => {
  const mobile = useIsMobile();
  if (mobile) return <DesktopNotice backTo={backTo} backLabel={backLabel} />;
  return <div className="h-full">{children}<FeedbackButton /></div>;
};
